import {SiteType} from '@wp-content-publisher/typings-lib/dist/src/server/types/site.ts';
import {apiRequest} from '../../../shared/utils/api-request.helper.ts';


export const removeArticle = async (id: number): Promise<SiteType[]> =>
    await apiRequest({
        url: `/articles/${id}`,
        options: {method: 'DELETE'}
    });